import React, { createContext, useState, useContext, useEffect } from 'react';
import { getStoredAdmin, getStoredToken, adminLogout } from '../services/admin/authService';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedAdmin = getStoredAdmin();
    const storedToken = getStoredToken();
    
    if (storedAdmin && storedToken) {
      setAdmin(storedAdmin);
      setToken(storedToken);
    }
    setLoading(false);
  }, []);

  const login = (adminData, tokenData) => {
    setAdmin(adminData);
    setToken(tokenData);
  };

  const logout = () => {
    adminLogout();
    setAdmin(null);
    setToken(null);
  };

  const isAuthenticated = () => {
    return !!token && !!admin;
  };

  const hasPermission = (permission) => {
    if (!admin) return false;
    if (admin.is_super_admin) return true;
    return admin.roles?.[permission] || false;
  };

  return (
    <AdminContext.Provider
      value={{
        admin,
        token,
        loading,
        login,
        logout,
        isAuthenticated,
        hasPermission
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
